import React from 'react';
import Obfuscate from 'react-obfuscate';
import contactLinkStyles from './contactlinks.module.sass';

export default props => {

  const { addClass } = props
  return (
    <ul className={[contactLinkStyles.contactlinks, addClass].join(' ')}>
      <li className={contactLinkStyles.list}>
        <Obfuscate
          className={contactLinkStyles.anchor}
          email='oink@trufflepigs.com'
          headers={
            { subject: 'Email from TrufflePigs.com' }
          }
        />
      </li>
      <li className={contactLinkStyles.list}>
        <a className={contactLinkStyles.anchor} href="tel:250-343-6303" rel="tel">250.343.6303</a>
      </li>
    </ul>
  );
};
